<template>
  <div v-if="post">
    <div :class="['post', slug]">
      <Header :id="post.header.id" :currentPage="slug" v-if="post.header" />
      <div class="content">
        <h1 v-if="post.title" class="content-title">{{post.title}}</h1>
        <template v-for="(block, index) in post.content">
          <RichText :id="block.id" :key="index" v-if="block.__typename === 'RichTextRecord'" />
          <Social :className="slug + '-post-social'" :id="block.id" :key="index" v-if="block.__typename === 'SocialContentRecord'" />
          <CallToAction :id="block.id" :key="index" v-if="block.__typename === 'CallToActionRecord'" />
        </template>
      </div>
      <Footer :id="post.footer.id" v-if="post.footer" />
    </div>
  </div>
</template>

<script>
import Header from 'components/Header.vue'
import Footer from 'components/Footer.vue'
import RichText from 'components/RichText.vue'
import Social from 'components/Social.vue'
import CallToAction from 'components/CallToAction.vue'

import gql from 'graphql-tag'

export default {
  name: 'Post',
  components: {
    Header,
    Footer,
    RichText,
    Social,
    CallToAction
  },
  props: [
    'slug',
    'year',
    'month',
    'day'
  ],
  data() {
    return {
      post: {},
      loading: 0
    }
  },
  metaInfo () {
    return {
      title: this.metaTitle,
      meta: [
        { name: 'description', content: this.metaDescription }
      ]
    }
  },
  computed: {
    metaTitle() {
      return this.post.seo && this.post.seo.title ? this.post.seo.title : this.post.title;
    },
    metaDescription() {
      if (!this.post || !this.post.seo || !this.post.seo.description) return '';
      return this.post.seo.description;
    }
  },
  apollo: {
    post: {
      query: gql`query Post ($slug: String, $publicationStart: DateTime, $publicationEnd: DateTime) {
        post ( filter: { 
          slug: { eq: $slug },
          date: { gt: $publicationStart, lt: $publicationEnd }
        } ) {
          title
          header { id }
          content {
            ... on RichTextRecord { id }
            ... on SocialContentRecord { id }
            ... on CallToActionRecord { id }
          }
          footer { id }
          seo {
            description
            title
          }
        }
      }`,
      loadingKey: 'loading',
      variables() {
        return {
          slug: this.slug,
          publicationStart: new Date(Date.UTC(
            parseInt(this.year, 10),
            parseInt(this.month, 10) - 1, 
            parseInt(this.day, 10),
            0, 0, 0
          )),
          publicationEnd: new Date(Date.UTC(
            parseInt(this.year, 10),
            parseInt(this.month, 10) - 1,
            parseInt(this.day, 10) + 1,
            0, 0, 0
          ))
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
@import "~@/assets/styles/breakpoints.less";

.content {
  background-color: #ffffff;
  padding: 10px 20px;
  display: flow-root;

  & h1.content-title {
    margin: 0.2em 0;
    padding: 0;
    font-family: LeagueGothicRegular,Arial,sans-serif;
    font-size: 30px;
    line-height: 35px;
    font-weight: normal;
    text-transform: uppercase;
  }

  & /deep/ ul, /deep/ ol {
    font-size: 15px;
    line-height: 20px;
    margin: 10px 0;
    padding: 0 0 0 40px;
    color: #0F0F0F;
    list-style: circle outside none;

    & li {
      padding: 0;
      color: #0F0F0F;
      margin: 0.2em 0;
    }
  }

  & /deep/ ol {
    list-style: decimal outside none;
  }

  & /deep/ a {
    color: #006699;
    text-transform: none;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  & /deep/ p {
    font-size: 15px;
    line-height: 20px;
    margin: 1.2em 0;
    padding: 0;
  }

  & /deep/ img[src*="#w50"] {
   width: 50%;
  }

  & /deep/ img[src*="#alignright"] {
   float: right;
  }

  & /deep/ img[src*="#alignleft"] {
   float: left;
  }

  & /deep/ img[src*="#w100"] {
   width: 100%;
  }

  & /deep/ pre {
    white-space: pre-wrap;
    font-size: 1.4em;
  }
}

@media @for-phone {
  /deep/ .content {
    & pre {
      font-size: 1em;
    }

    & img[src*="#w50"] {
     width: 100%;
    }
  }
}
</style>
